import React, {FC, useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {Button} from "primereact/button";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import {routes} from "../../../app/routes";
import TextInput from "../../../components/form/TextInput";
import {useCreateCityMutation, useFindCityByIdQuery, useUpdateCityMutation} from "../../../api/eventsStoreApi";
import {
    initialCityState,
    selectSettingState, setCityProperty,
    setSettingData
} from "../../../slices/settingsSlice";
import {ProgressSpinner} from "primereact/progressspinner";

const UpdateCity: FC<{}> = ({}) => {
    const {id = ""} = useParams();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const {isLoading: isPrepareLoading} = useFindCityByIdQuery(
        {id: id},
        {skip: id === ""}
    );
    const [
        updateCity,
        {isLoading: isUpdateLoading, isSuccess: isUpdateSuccess},
    ] = useUpdateCityMutation();
    const [
        createCity,
        {isLoading: isCreateLoading, isSuccess: isCreateSuccess},
    ] = useCreateCityMutation();

    const {city} = useAppSelector(selectSettingState);
    const {name} = city;

    const isSuccess = isUpdateSuccess || isCreateSuccess;

    useEffect(() => {
        dispatch(setSettingData({property: "city", value: initialCityState}));

        if (isSuccess) {
            navigate(`/${routes.SETTINGS}/${routes.CITIES}`);
        }
    }, [navigate, isSuccess]);

    const onSubmit = () => {
        !!id
            ? updateCity({id: id, cityDto: city})
            : createCity({cityDto: city});
    };

    return (
        <>
            <div className="grid m-5">
                <h3 className="text-center p-1 mt-0">
                    {!id
                        ? `Add city`
                        : `Update city ${name}`}
                </h3>
                <TextInput
                    id="name"
                    name="name"
                    value={name}
                    label="Nazwa"
                    setProperty={setCityProperty}
                />
                {isCreateLoading || isUpdateLoading ?
                    <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}><ProgressSpinner/>
                    </div> : <Button label="Zapisz" className="mt-5 w-full" onClick={onSubmit}/>}
            </div>
        </>
    );
};

export default UpdateCity;
